module.exports = __webpack_public_path__ + "static/media/Program6.c9090094.jpg";